export default __webpack_public_path__ + "static/media/45acab2a7b6145ac.b6f2bf48155eb0b680bd02c9f449c0e8.svg";